/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { memo, useMemo } from "react";

export interface SvgIconProps {
  className?: string;
  SvgComponent?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  size?: "small" | "medium" | "large";
  color?: string;
  value?: number | string;
}

export default memo(function SvgIcon(props: SvgIconProps) {
  const { className, SvgComponent, size, value = 12, color } = props;

  const _size: number = useMemo(() => {
    let value = 24;
    switch (size) {
      case "small":
        value = 16;
        break;
      case "medium":
        value = 24;
        break;
      case "large":
        value = 30;
        break;
      default:
        break;
    }
    return value;
  }, [size]);

  return SvgComponent ? (
    <SvgComponent
      fill="currentColor"
      fontSize="inherit"
      width={value ?? _size}
      height={value ?? _size}
      css={css`
        display: inline-block;
        color: ${color};
      `}
      className={className}
    />
  ) : null;
});
